import {Component} from 'react';
import withQueryStringProps from '../../components/withQueryStringProps';

@withQueryStringProps(['print'])
class HideIfPrint extends Component {
  render() {
    if (!this.props.print) {
      return this.props.children;
    } else {
      return null;
    }
  }
}

export default HideIfPrint;



// WEBPACK FOOTER //
// ./src/components/HideIfPrint/HideIfPrint.js